import { useEffect } from 'react'
import { useClerk } from '@clerk/clerk-react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

export default function LogoutPage() {
  const { signOut } = useClerk()
  const navigate = useNavigate()

  useEffect(() => {
    const handleSignOut = async () => {
      try {
        await signOut()
        // Redirect to browse page after sign out
        navigate('/')
      } catch (error) {
        console.error('Sign out error:', error)
        // Still redirect even if there's an error
        navigate('/')
      }
    }

    handleSignOut()
  }, [signOut, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">正在退出登录...</p>
      </div>
    </div>
  )
}
